export function useSortedMutations({ mutations, sortBy, sortAscending }) {
  if (!sortBy) {
    return mutations;
  }
  const sortedMutations = mutations.slice(0).sort((a, b) => {
    if (sortBy === 'title') {
      return a.attr('title').localeCompare(b.attr('title'));
    }

    const valueA = a.attr('results')?.resources()?.list()?.find((result) => result.attr('title') === sortBy)
      ?.attr('valueSortable');
    const valueB = b.attr('results')?.resources()?.list()?.find((result) => result.attr('title') === sortBy)
      ?.attr('valueSortable');

    const numericA = +valueA;
    const numericB = +valueB;
    if (!Number.isNaN(numericA) && !Number.isNaN(numericB)) {
      return numericA - numericB;
    }
    return valueA.localeCompare(valueB);
  });
  if (!sortAscending) sortedMutations.reverse();
  return sortedMutations;
}
